import { API_BASE_URL } from '../../common/constants';
import axios, { AxiosError, AxiosResponse } from 'axios';
import { getHeaders } from './helpers';
import { axiosResponseHandler } from '../CloudFunctionsService';
import { PropertyItem } from '../realtime-db/users/users.types';

class Property {
  /**
   *
   */
  async update(userId: string, accountId: string, newProperties: PropertyItem[]) {
    const response = axios.post(
      API_BASE_URL + '/accountPropertyUpdate',
      {
        userId: userId,
        accountId: accountId,
        properties: newProperties,
      },
      {
        headers: getHeaders(),
      },
    );
    return axiosResponseHandler(response);
  }
  /**
   *
   */
  async add(userId: string, newProperties: PropertyItem[]) {
    const response = axios.post(
      API_BASE_URL + '/accountPropertyAdd',
      {
        userId: userId,
        properties: newProperties,
      },
      {
        headers: getHeaders(),
      },
    );
    return axiosResponseHandler(response);
  }
}

export default Property;
